import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { type ModuleConfigState, type ModuleId, type ModuleResult } from '@pixacare/forms';
import { FormGridTriggerComponent } from '../form-grid-trigger/form-grid-trigger.component';
import { FormGridService } from '../services/form-grid.service';

@Component({
  selector: 'pxc-form-grid-section-cell',
  templateUrl: './form-grid-section-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormGridTriggerComponent],
})
export class FormGridSectionCellComponent {
  readonly entityKey = input.required<string>();
  readonly type = input.required<string>();
  readonly sectionId = input.required<string>();

  private readonly formGridService = inject(FormGridService);

  readonly moduleInputs = computed(() => this.formGridService.moduleInputs(this.entityKey(), this.type())());

  readonly isHidden = computed(() =>
    this.formGridService.isSectionHidden(this.entityKey(), this.type(), this.sectionId()),
  );

  private readonly isReadonly = computed(() => this.formGridService.mode(this.entityKey(), this.type()) === 'readonly');

  readonly modules = computed<ModuleConfigState[]>(() =>
    this.isReadonly() || this.isHidden()
      ? []
      : this.formGridService.sectionModules(this.entityKey(), this.type(), this.sectionId()),
  );

  protected resetModule(event: { moduleId: ModuleId; targetId: string }): void {
    this.formGridService.resetModuleResult(this.entityKey(), this.type(), event.moduleId, event.targetId);
  }

  protected applyModule(event: { moduleId: ModuleId; targetId: string; result: ModuleResult }): void {
    this.formGridService.applyModuleResult(this.entityKey(), this.type(), event.moduleId, event.targetId, event.result);
  }
}
